var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"app__spinner",attrs:{"size":_vm.size,"width":_vm.size / 10,"color":_vm.color,"indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }